/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const MerchantCenterProductDestination = {
/**
     * Allow your products to show in Shopping ads.
     */    ShoppingAds: 'Shopping_ads',
/**
     * Allow your products to show in dynamic remarketing ads.
     */    DisplayAds: 'Display_ads',
/**
     * Allow your products to show in ads to shoppers near your store.
     */    LocalInventoryAds: 'Local_inventory_ads',
/**
     * Allow your products to appear in free listings on Google.
     */    FreeListings: 'Free_listings',
/**
     * Allow your local products to appear in free local product listings on Google.
     */    FreeLocalListings: 'Free_local_listings',
/**
     * Allow your product information to flow to your Cloud retail project if you have an active link.
     */    CloudRetail: 'Cloud_retail',
/**
     * Allow your product information to flow to your Cloud retail project if you have an active link.
     */    LocalCloudRetail: 'Local_cloud_retail'
};
